<div class="notice">
  <button class="close" aria-label="Cerrar" (click)="close()">×</button>

  @if (variant === 'dates') {
    <div class="header">
      <span class="tag">Novedad</span>
      <h2 id="emissions-notice-title">Llega la nueva experiencia.</h2>
      <p>
        Durante unos días vas a poder usar las dos versiones de nuestra
        plataforma.
      </p>
    </div>

    <div class="timeline">
      @for (step of steps; track step.title; let last = $last) {
        <div class="step" [class.end]="last">
          <div class="date">
            <b>{{ step.day }}</b>
            <small>{{ step.month }}</small>
          </div>
          <div>
            <h3>{{ step.title }}</h3>
            <p>{{ step.description }}</p>
            <div class="designs">
              <span [class.off]="!step.oldDesignAvailable">Emisiones</span>
              <span class="on">Emisiones nuevo diseño</span>
            </div>
          </div>
        </div>
      }
    </div>

    <div class="banner-info">
      <div class="banner">
        <span class="banner-icon">✦</span>
        <span class="banner-text">Estás usando el nuevo diseño de Emisiones.</span>
        <span class="banner-action">Volver al diseño anterior</span>
      </div>
      <div>
        <h4>No tenés que hacer nada</h4>
        <p>
          Vas a ver este banner arriba de Emisiones. Desde ahí podés volver al
          diseño anterior hasta el 9/11.
        </p>
      </div>
    </div>

    <div class="footer">
      <p>¿Dudas? <b>Hablá con tu ejecutivo de cuentas.</b></p>
      <button class="btn" (click)="close()">Entendido</button>
    </div>
  } @else {
    <div class="header">
      <span class="tag">Próximamente</span>
      <h2 id="emissions-notice-title">Emitir va a ser más ágil y claro</h2>
      <p>
        Escuchamos a nuestros usuarios y estamos renovando Emisiones para que
        trabajes más rápido.
      </p>
    </div>

    <div class="benefits">
      @for (benefit of benefits; track benefit.title) {
        <div>
          <i>{{ benefit.icon }}</i>
          <b>{{ benefit.title }}</b>
          <span>{{ benefit.description }}</span>
        </div>
      }
    </div>

    <div class="footer">
      <p>Muy pronto te contamos la fecha.</p>
      <button class="btn" (click)="close()">Entendido</button>
    </div>
  }
</div>
